export default "__VITE_ASSET__BIP4YFHr__"